import {
    IProps,
} from './types';

import React, {
    FC,
} from 'react';

const CheckboxInput: FC<IProps> = (props) => {
    return (
        <input
            className={props.className}
            type={'checkbox'}
            checked={props.value}
            disabled={props.isDisabled}
            onChange={(e) => props.onChangeValue(e.target.checked)}
        />
    );
};

export default CheckboxInput;
